import UserEntitlements from './user-entitlements';
import initContentReadingTracking from '../../analytics/src/datalayer-content-reading-tracking';
import DatalayerUsrSegment from '../../analytics/src/datalayer/datalayer-usr-segment';

window.userEntitlements = UserEntitlements;

const pianoLibrary = document.querySelector( '#piano-variable-init' );

if ( pianoLibrary && pianoLibrary.dataset.authState !== 'no-auth' ) {
	new window.userEntitlements( window.dataLayer || [] ).buildUserContext( true );

	initContentReadingTracking();
} else {
	const datalayerUsrSegment = new DatalayerUsrSegment();
	datalayerUsrSegment.init( false );
}
